"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Accordion.default;
  }
});

var _Accordion = _interopRequireDefault(require("./Accordion"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Accordion/index.js
// module id = 429
// module chunks = 0